module.exports = "<ng-template></ng-template>";